import "silverstripe"

interface FileUploadActionBindings {

}

const supportedFileTypes = [
    'application/vnd.google-earth.kml+xml',
    'application/json',
    'application/geo+json',
    'application/gpx+xml',
];

export class FileUploadActionController implements ng.IComponentController, FileUploadActionBindings {
    constructor(protected $element: JQLite, protected $scope: ng.IScope) {
        console.log($element);

    }

    file: File;

    isFileSupported() {
        return this.file && supportedFileTypes.includes(this.file.type);
    }

    handleChange($event: any) {
        console.log($event);
    }

    $postLink() {
        const fileInput = this.$element.find('input');

        console.log(fileInput);

        fileInput.on('change', (ev) => {
                console.log(ev);
                const target = ev.target as HTMLInputElement;
                const files = target.files;
                const file = files.item(0);
                this.$scope.$apply(() => {
                    this.file = file;
                });
            });
    }
}

const _t = (identifier: string, fallbackStr?: string, priority?: any, context?: any) => window.ss.i18n._t(identifier, fallbackStr, priority, context);

export class FileUploadAction implements ng.IComponentOptions {
    controller = ['$element', '$scope', FileUploadActionController];
    bindings: {

    };
    template =
`<label class="div-like add-feature-action"
        ng-click="$ctrl.toggleMode('fromFile')"
        data-action="pickFeatureFile">
    <span class="btn-icon-only btn-plain">
        <i class="icon icon-files-empty"></i>
    </span>
    <span class="add-feature-action-label">
        ${_t('FEATURES_PANE.FROM_FILES', "Pick a file to query")}
    </span>
    <input type="file" style="display: none;">
</label>

<p ng-if="$ctrl.file && !$ctrl.isFileSupported()">
    Unsupported file type {{ $ctrl.file.type }}
</p>

<p>
    ${_t('FEATURES_PANE.SUPPORTED_FILES', 'Supported file types include KML, GeoJSON, and shapefile.')}
</p>`
}